import dancingRoom from '@/assets/img/users-cases/dancing-room.webp';
import dancingRoomHow from '@/assets/img/users-cases/dancing-room-how.webp';
import dancingRoomResult from '@/assets/img/users-cases/dancing-room-result.webp';

export default {
  slug: 'dancing-room',
  order: 14,
  title: 'Dance Studio 3D Tour',
  subtitle: 'Open studio layouts with animated 3D previews',
  tags: ['commercialSpace', 'activityspace'],

  images: {
    hero: dancingRoom,
    aboutTop: dancingRoomHow,
    aboutBottom: dancingRoomResult,
  },

  howText:
    'We prepared dancing room floor plan, 2D and 3D layouts, and interior design for dancing room, considering lighting, mirrors, and safe circulation.',

  resultText:
    'Ready plans allow clients to present studios to investors, use for marketing, and quickly launch dance facilities.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
